import PropTypes from 'prop-types';

import Image from '../shared/propTypes/Image';

/**
 * @typedef {Object} RoomType
 * @property {string} [id]
 * @property {string} [name]
 * @property {string} [description]
 * @property {string[]} [facilities]
 * @property {import('../shared/propTypes/Image').Image|null} [mainImage]
 * @property {number} [maxOccupants]
 */
const RoomType = {
  id: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  facilities: PropTypes.arrayOf(PropTypes.string),
  mainImage: PropTypes.shape(Image),
  maxOccupants: PropTypes.number,
};

export default RoomType;
